import React, { createContext, useContext, useMemo } from 'react'
import PropTypes from 'prop-types'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { Box, IconButton } from '@mui/material'
import { DragIndicator } from '@mui/icons-material'

const SortableItemContext = createContext({
    attributes: {},
    listeners: undefined,
    isDragging: false,
    ref() {},
})

const SortableItem = ({ children, id }) => {
    const {
        attributes,
        isDragging,
        listeners,
        setNodeRef,
        setActivatorNodeRef,
        transform,
        transition,
    } = useSortable({ id })

    const context = useMemo(() => ({ attributes, listeners, ref: setActivatorNodeRef }), [attributes, listeners, setActivatorNodeRef])

    return (
        <SortableItemContext.Provider value={context}>
            <Box
                component='li'
                ref={setNodeRef}
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexGrow: 1,
                    alignItems: 'center',
                    listStyle: 'none',
                    fontWeight: 400,
                    padding: '0 1rem',
                    opacity: isDragging ? 0.4 : undefined,
                    transform: CSS.Translate.toString(transform),
                    transition,
                }}
            >
                {children}
            </Box>
        </SortableItemContext.Provider>
    )
}

SortableItem.propTypes = {
    children: PropTypes.node.isRequired,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
}

const DragHandle = () => {
    const { attributes, isDragging, listeners, ref } = useContext(SortableItemContext)

    return (
        <IconButton
            {...attributes}
            {...listeners}
            ref={ref}
            size='small'
            sx={{ cursor: isDragging ? 'grabbing' : 'grab' }}
        >
            <DragIndicator />
        </IconButton>
    )
}

export {
    SortableItem,
    DragHandle,
}